const notificationMapping = {
  Task: "tms",
  Grievance: "gms",
  Ticket: "customersupport",
  Report: "reports",
  Survey: "survey"
};
export default notificationMapping;
